/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Late_Fine_Firefox_StirInputs */

const fr_late_fine_firefox_stir = /** @type {(inputs: Late_Fine_Firefox_StirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes séances`)
};

/**

* @param {Late_Fine_Firefox_StirInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const late_fine_firefox_stir = /** @type {((inputs?: Late_Fine_Firefox_StirInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Late_Fine_Firefox_StirInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_late_fine_firefox_stir(inputs)
});